export default "__VITE_ASSET__tMKY5BGn__"